import { margin } from '@lib/style/mixins/margin';
import { padding } from '@lib/style/mixins/padding';
import MUIDialogActions from '@material-ui/core/DialogActions';
import Divider from '@material-ui/core/Divider';
import React from 'react';
import styled from 'styled-components';

export const DialogActions = styled(({ divider, ...props }) => {
    margin.clean(props);
    padding.clean(props);

    return (
        <>
            {divider ? <Divider style={{ width: '100%' }} /> : null}
            <MUIDialogActions {...props} />
        </>
    );
})`
    && {
        ${margin(0)}
        ${padding('16px 16px 16px 20px')}
    }
`;
